import { type Theme, styled } from 'baseui';
export const Container = styled('section', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  height: `calc(100% - ${$theme.sizing.scale2400})`,
  overflow: 'auto'
}));
export const SubContainer = styled('section', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: `${$theme.sizing.scale600} 0`,
  gap: $theme.sizing.scale600
}));
export const SectionHeader = styled('div', () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));
export const ButtonContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  gap: $theme.sizing.scale300
}));
export const ListContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.sizing.scale100
}));
export const ListItemContainer = styled<'div', {
  $isLast: boolean;
}>('div', ({
  $theme,
  $isLast
}: {
  $isLast: boolean;
  $theme: Theme;
}) => ({
  display: 'flex',
  alignItems: 'center',
  padding: `${$theme.sizing.scale300} ${$theme.sizing.scale100}`,
  ...(!$isLast && {
    borderBottom: `1px solid ${$theme.colors.borderOpaque}`
  })
}));
export const ListItemContent = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  gap: $theme.sizing.scale100,
  alignItems: 'center',
  flex: 1,
  minWidth: 0
}));
export const ExpandedItemContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: $theme.sizing.scale200,
  border: `${$theme.sizing.scale0} solid ${$theme.colors.borderOpaque}`,
  borderRadius: $theme.borders.radius300,
  padding: $theme.sizing.scale300
}));
export const ExpandedItemHeader = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: $theme.sizing.scale300
}));
export const ActionButtonContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale100
}));
export const StyledCheckBox = styled('div', ({
  $theme
}) => ({
  width: $theme.sizing.scale600,
  height: $theme.sizing.scale600,
  cursor: 'pointer',
  marginRight: $theme.sizing.scale100
}));